import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

function Native({ isNative, onChange }) {
  const handleChange = (event) => {
    onChange({
      target: {
        name: "isNative",
        value: event.target.checked,
      },
    });
  };

  return (
    <FormControlLabel
      control={<Checkbox checked={isNative} onChange={handleChange} />}
      label={"Native"}
    />
  );
}

export default Native;
